/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ExtensionTelemetryConsentStateEnum = {
    granted: 'granted',
    noDecision: 'no_decision',
    refused: 'refused'
};
/**
 * Check if a given object implements the ExtensionTelemetryConsent interface.
 */
export function instanceOfExtensionTelemetryConsent(value) {
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
export function ExtensionTelemetryConsentFromJSON(json) {
    return ExtensionTelemetryConsentFromJSONTyped(json, false);
}
export function ExtensionTelemetryConsentFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clauseVersion': json['clauseVersion'] == null ? undefined : json['clauseVersion'],
        'decidedAt': json['decidedAt'] == null ? undefined : (new Date(json['decidedAt'])),
        'schemaVersion': json['schemaVersion'] == null ? undefined : json['schemaVersion'],
        'state': json['state'],
        'withdrawnAt': json['withdrawnAt'] == null ? undefined : (new Date(json['withdrawnAt'])),
    };
}
export function ExtensionTelemetryConsentToJSON(json) {
    return ExtensionTelemetryConsentToJSONTyped(json, false);
}
export function ExtensionTelemetryConsentToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clauseVersion': value['clauseVersion'],
        'decidedAt': value['decidedAt'] == null ? value['decidedAt'] : value['decidedAt'].toISOString(),
        'schemaVersion': value['schemaVersion'],
        'state': value['state'],
        'withdrawnAt': value['withdrawnAt'] == null ? value['withdrawnAt'] : value['withdrawnAt'].toISOString(),
    };
}
